import NavBar from '@/components/NavBar/NavBar.vue';
import CustomTable from '@/components/CustomTable/CustomTable.vue';
import { API_BASE_URL } from "@/config";
import { validateToken } from '@/utils/auth';
import { LOGOUT } from "@/utils/logout.js";
import { useToast } from "@/components/Toast/useToast";

export default {
  name: 'QuestionManagement',
  mixins: [LOGOUT],
  pageTitle: 'Question Management',
  setup() {
    const { showSuccess, showError, showWarning } = useToast();
    
    return {
      showSuccess,
      showError,
      showWarning,
    };
  },
  components: {
    NavBar,
    CustomTable
  },
  data: () => ({
    create_question_data: { question: '', question_type: '', mandatory: '', options: [], number_of_options: 0},
    edit_question_data: { question: '', question_type: '', mandatory: '', options: [] },

    question_id: '',
    question_status: '',
    loading: false,
    columns: [
      { label: 'Question', key: 'question' },
      { label: 'Question Type', key: 'question_type' },
      { label: 'Options (if applicable)', key: 'options' },
    ],
    table_key: 0
  }),
  methods: {
    resetCreateForm() {
      this.create_question_data = {
        question: '',
        question_type: '',
        mandatory: '',
        options: [],
        number_of_options: 0
      };
    },
    validation_message_list(document_id, value) {
      if (value.includes('')) {
        $(document_id).removeClass('d-none');
        return false;
      }
      else {
        $(document_id).addClass('d-none');
        return true;
      }
    },
    validation_message(document_id, value) {
      if (value == '') {
        $(document_id).removeClass('d-none');
        return false;
      }
      else {
        $(document_id).addClass('d-none');
        return true;      
      }
    },
    create_question() {
      const TOKEN = localStorage.getItem('token');
      const BASE_URL = API_BASE_URL;
      const ADD_QUESTION_URL = `${BASE_URL}/verify_api/question_management_api/save_question_api/`;
      
      let options = this.create_question_data.options;
      if (this.create_question_data.question_type !== 'Selection' && this.create_question_data.question_type !== 'Checkbox' && this.create_question_data.question_type !== 'Multi Selection') {
          options = [];  // Clear options if not relevant for the question type
      }

      const validations = [
        this.validation_message('#question-error', this.create_question_data.question),
        this.validation_message('#question-type-error', this.create_question_data.question_type),
        this.validation_message('#mandatory-field-error', this.create_question_data.mandatory)
      ];

      if (this.create_question_data.question_type == 'Selection' || this.create_question_data.question_type == 'Checkbox' || this.create_question_data.question_type == 'Multi Selection') {
        validations.push(this.validation_message_list('#option-field-error', this.create_question_data.options));
      }

      if (validations.includes(false)) {
        return;
      }

      const FORM_DATA = {
        question: this.create_question_data.question,
        question_type: this.create_question_data.question_type,
        mandatory: this.create_question_data.mandatory,
        options: options
      };

      $.ajax({
        method: "POST",
        url: ADD_QUESTION_URL,
        data: JSON.stringify(FORM_DATA),
        contentType: 'application/json',
        headers: {
          Authorization: `Token ${TOKEN}`

        },
        success: (response) => {
          this.showSuccess(response.message);
          this.resetCreateForm();
          this.table_key++;
        },
        error: (error) => {
          let error_message = 'An error occurred while creating the question.';
          
          if (error.responseJSON && error.responseJSON.error) {
            error_message = error.responseJSON.error;
          }

          this.showError(error_message);
        }
      });
    },
    get_questions(page = 1, search = '') {
      const TOKEN = localStorage.getItem('token');
      let url = `${API_BASE_URL}/verify_api/question_management_api/get_questions_api/?page=${page}`;
      if (search) {
        url += `&search=${encodeURIComponent(search)}`;
      }
      return new Promise((resolve, reject) => {
        $.ajax({
          url,
          method: 'GET',
          contentType: 'application/json',
          headers: {
            Authorization: `Token ${TOKEN}`
          },
          success: (response) => {
            resolve({
              count: response.count,
              results: response.results
            });
          },
          error: (xhr, status, error) => {
            reject(error);
          }
        });
      });
    },
    edit_question(question) {
      this.selected_question_id = question.id;
      this.edit_question_data.question = question.question;
      this.edit_question_data.question_type = question.question_type;
      this.edit_question_data.mandatory = question.is_required;
      this.edit_question_data.options = question.options.map(option => option.option)
      if (this.edit_question_data.question_type == 'Selection' || this.edit_question_data.question_type == 'Checkbox' || this.edit_question_data.question_type == 'Multi Selection') {
          this.edit_question_data.number_of_options = this.edit_question_data.options.length;
      }

      this.$nextTick(() => {
        $('#edit_question_modal').modal('show');
      });
    },
    edit_validate_number_of_options() {
      if (this.edit_question_data.number_of_options > 150) {
        this.edit_question_data.number_of_options = 150;
        this.showError("You cannot enter more than 150 options.");
      }
      // Update the options array dynamically
      this.edit_options_array();
    },
    edit_options_array() {
      if(this.edit_question_data.number_of_options > 0) {
        // If the number of options is reduced, remove excess options
        if (this.edit_question_data.number_of_options < this.edit_question_data.options.length) {
          this.edit_question_data.options.splice(this.edit_question_data.number_of_options);
        }
        // If the number of options is increased, add empty slots
        while (this.edit_question_data.options.length < this.edit_question_data.number_of_options) {
          this.edit_question_data.options.push('');
        }
      }
    },
    update_question(){
      const TOKEN = localStorage.getItem('token');
      const EDIT_QUESTION_API_URL = `${API_BASE_URL}/verify_api/question_management_api/update_question_api/`;

      const FORM_DATA = {
        question_id: this.selected_question_id, // Set the selected project ID here
        question: this.edit_question_data.question,
        question_type: this.edit_question_data.question_type,
        mandatory: this.edit_question_data.mandatory,
        options: this.edit_question_data.options
      };

      $.ajax({
        url: EDIT_QUESTION_API_URL,
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(FORM_DATA),
        headers: {
          Authorization: `Token ${TOKEN}`
        },
        beforeSend: () => {
          // Remove loading modal for better UX
        },
        success: () => {
          this.showSuccess('Question updated successfully');
          $('#edit_question_modal').modal('hide');
          this.table_key++;
        },
        error: () => {
          this.showError('An error occurred while updating question');
        }
      });
    },
    validate_number_of_options() {
      if (this.create_question_data.number_of_options > 150) {
        this.create_question_data.number_of_options = 150;
        this.showError("You cannot enter more than 150 options.");
      }
      // Update the options array dynamically
      this.update_options_array();
    },
    update_options_array() {
      // If the number of options is reduced, remove excess options
      if (this.create_question_data.number_of_options < this.create_question_data.options.length) {
        this.create_question_data.options.splice(this.create_question_data.number_of_options);
      }
      // If the number of options is increased, add empty slots
      while (this.create_question_data.options.length < this.create_question_data.number_of_options) {
        this.create_question_data.options.push('');
      }
    },
    deactivate_question(question_id){
      const TOKEN = localStorage.getItem('token');
      const DEACTIVATE_QUESTION_API_URL = `${API_BASE_URL}/verify_api/question_management_api/change_question_status_api/`;

      const FORM_DATA = {
        question_id: question_id, // Set the selected project ID here
        question_status: 'inactive'
      };

      $.ajax({
        url: DEACTIVATE_QUESTION_API_URL,
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(FORM_DATA),
        headers: {
          Authorization: `Token ${TOKEN}`
        },
        beforeSend: () => {
          // Remove loading modal for better UX
        },
        success: () => {
          this.table_key++;
        },
        error: () => {
          this.showError('An error occurred while deactivating question');
        }
      });
    },
    activate_question(question_id){
      const TOKEN = localStorage.getItem('token');
      const ACTIVATE_QUESTION_API_URL = `${API_BASE_URL}/verify_api/question_management_api/change_question_status_api/`;

      const FORM_DATA = {
        question_id: question_id, // Set the selected project ID here
        question_status: 'active'
      };

      $.ajax({
        url: ACTIVATE_QUESTION_API_URL,
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(FORM_DATA),
        headers: {
          Authorization: `Token ${TOKEN}`
        },
        beforeSend: () => {
          // Remove loading modal for better UX
        },
        success: () => {
          this.table_key++;
        },
        error: () => {
          this.showError('An error occurred while activating question');
        }
      });
    },
    redirect_to_conditional_questions(question_id) {
      this.$router.push({ 
          name: 'conditional_questions',
          params : { question_id }
      });
    }
  },
  
  computed: {
    check_question_type(){
      return this.create_question_data.question_type === 'Checkbox' || this.create_question_data.question_type === 'Selection' || this.create_question_data.question_type === 'Multi Selection';
    },
    check_edit_question_type() {
      return this.edit_question_data.question_type === 'Checkbox' || this.edit_question_data.question_type === 'Selection' || this.edit_question_data.question_type === 'Multi Selection';
    }
  },
  mounted() {
    if (!validateToken(this.$router)) {
      return;
  }
    this.get_questions();
  }
};
